import { reactive } from 'vue';

export const criarPlaMpItem = () => {
  return reactive({
    id: 0,
    idplamp: 0,
    idproduto: 0,
    detalhamento: '',
    dtrecebimento: '',
    nmfornecedor: '',
    sif_origem: '',
    nrdoc_origem: 0,
    temperatura: 0,
    dtvalidade: '',
    qtd: 0,
    unidade: '',
    lote: '',
    idlogin: 0,
    idusuario: 0
  });
};